import { CloseCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Divider, Form, Input, Modal, Row, message } from 'antd';
// core components
import colors from 'constants/colors';
import { amesSendMail } from 'helpers/MailHelper';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePassword, updatePassword_hanhtrangso } from 'services/AuthService';
import { randomString } from 'utils/randomFunc';
import { login } from '../../actions';
import { checkExistsEmail } from 'modules/Administration/components/Users/api/user_api';

const backgroundImage = require('assets/img/home/Books_laptop.png').default;

const clientId = '596542930788-orcbsdlf3a8f3bfl31plh4jn2ia1jr8u.apps.googleusercontent.com';

export default ({ onClose }) => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.authReducer.error);
  const loading = useSelector((state) => state.authReducer.loading);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [emailResetPassword, setEmailResetPassword] = useState();
  const [isDisableResetPasswodBtn, setIsDisableResetPasswodBtn] = useState(false);
  const [isLoadingResetPassword, setIsLoadingResetPassword] = useState(false);

  const onFinish = (values) => {
    const { email, password } = values;
    dispatch(login(email, password));
  };
  //API của hanhtrangso, để khi nào họ yêu cầu mở thì mở lại
  // const handleOk = async () => {
  //   message.info('Link khôi phục mật khẩu đã được gửi tới email của bạn.');
  //   const response = await hanhtrangsoClient.post('/Forgot-Password', { email: emailResetPassword, url: 'https://hanhtrangso.nxbgd.vn/quen-mat-khau/mat-khau-moi' });
  // };

  // const onForgotPassword = () => {
  //   window.open('https://aessso.nxbgd.vn:8443/realms/nxbgdSSO/login-actions/reset-credentials?client_id=HangTrangSo', '_blank');
  // }
  const onUpdatePassword = (values) => {
    try {
      setIsLoadingResetPassword(true);
      const GenPassword = randomString(2, 6);
      const email = values.emailResetPassword.toLowerCase();

      checkExistsEmail(email)
        .then((res) => {
          updatePassword({
            email: email,
            password: GenPassword,
          })
            .then((res2) => {
              updatePassword_hanhtrangso({ id: res?.id, password: GenPassword });
              const dataSendMail = {
                to: email,
                isSendFast: true,
                subject: `THÔNG BÁO THAY ĐỔI MẬT KHẨU`,
                templateMail: 'SACHSO_Mail_ResetPassword',
                templateData: {
                  email: email,
                  password: GenPassword,
                  studentName: res?.fullName,
                },
              };
              amesSendMail(dataSendMail)
                .then((res3) => {
                  message.success(`Mật khẩu mới đã được gửi về mail ${email}`,10);
                  setIsDisableResetPasswodBtn(true); // chặn việc click gửi lại password lần 2
                  setIsModalVisible(false);
                  setIsLoadingResetPassword(false);
                })
                .catch((err) => {
                  setIsLoadingResetPassword(false);
                  message.error('Gửi mail thay đổi mật khẩu thất bại!',10);
                });
            })
            .catch((err) => {
              setIsLoadingResetPassword(false);
              message.error('Có lỗi xảy ra!',10);
            });
        })
        .catch((err) => {
          setIsLoadingResetPassword(false);
          message.error('Không tìm thấy email này trong hệ thống !',10);
        });
    } catch (error) {
      setIsLoadingResetPassword(false);
      message.error('Có lỗi xảy ra! Vui lòng báo cho bộ phận cấp tài khoản',10);
    }
  };

  return (
    <>
      <Row>
        <Col lg={12} xs={24}>
          <div style={{ paddingTop: 32, paddingInline: 32 }}>
            <span style={{ fontSize: 24, fontWeight: 600, color: colors.font }}>ĐĂNG NHẬP</span>
          </div>
          <Divider />
          <div style={{ paddingInline: 32, paddingBottom: 32 }}>
            <Form layout='vertical' autoComplete='off' form={form} onFinish={onFinish} requiredMark={false}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label='Email'
                name='email'
                hasFeedback
                rules={[
                  { whitespace: true, message: 'Vui lòng nhập Email' },
                  { required: true, message: 'Vui lòng nhập Email' },
                ]}
              >
                <Input allowClear size='large' />
              </Form.Item>

              <Form.Item
                style={{ fontWeight: 600 }}
                label='Mật khẩu'
                name='password'
                // hasFeedback
                rules={[
                  { whitespace: true, message: 'Vui lòng nhập mật khẩu!' },
                  { required: true, message: 'Vui lòng nhập mật khẩu!' },
                ]}
              >
                <Input.Password allowClear size='large' />
              </Form.Item>
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between' }}>
                {/* <Checkbox>Lưu thông tin</Checkbox> */}
                <Button
                  type='link'
                  size='small'
                  onClick={() => setIsModalVisible(true)}
                  // onClick={onForgotPassword}
                >
                  Quên mật khẩu?
                </Button>
              </div>

              <Button loading={loading} size='large' className='mt-3 mb-2' htmlType='submit' type='primary' block style={{ fontWeight: 600, height: 48, borderRadius: '0.25rem' }}>
                ĐĂNG NHẬP
              </Button>

              {/* <GoogleLogin
                clientId={clientId}
                buttonText='Login'
                onSuccess={(response) => {
                  console.log('🚀', response.profileObj);
                }}
                onFailure={(response) => {
                  console.log('🚀', response);
                }}
                cookiePolicy='single_host_origin'
                render={(renderProps) => (
                  <Button
                    loading={loading}
                    size='large'
                    className='mt-0 mb-2'
                    type='primary'
                    htmlType='submit'
                    danger
                    block
                    style={{ fontWeight: 600, height: 48, borderRadius: '0.25rem' }}
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    icon={<GoogleOutlined />}
                  >
                    ĐĂNG NHẬP BẰNG GOOGLE
                  </Button>
                )}
              /> */}

              {error && error.event && <Alert message='Đăng nhập không thành công' type='error' showIcon style={{ marginBlock: 6, borderRadius: '0.25rem' }} />}
              {/* <div style={{ textAlign: 'center' }}>
                <span style={{ color: colors.greyChateau }}>Bạn chưa có tải khoản?</span>
                <Button type='link' size='small' onClick={() => {}}>
                  Đăng ký
                </Button>
              </div> */}
            </Form>
          </div>
        </Col>
        <Col lg={12} xs={0}>
          <div style={{ marginRight: -6 }}>
            <img src={backgroundImage} alt='ĐĂNG NHẬP' style={{ width: '100%' }} />
          </div>
          <div style={{ position: 'absolute', top: 0, right: 0, padding: 12 }}>
            <CloseCircleOutlined
              style={{ fontSize: 24, color: 'white', cursor: 'pointer' }}
              onClick={() => {
                // dispatch(closeModal());
                if (onClose && typeof onClose === 'function') {
                  onClose();
                }
              }}
            />
          </div>
        </Col>
      </Row>
      <Modal centered title='QUÊN MẬT KHẨU' visible={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null}>
        {/* <p style={{ fontWeight: 'bold' }}>Chúng tôi sẽ gửi quy trình đặt lại mật khẩu đến email của bạn.</p> */}
        <Form key='reset-password-form' onFinish={onUpdatePassword}>
          <Form.Item
            label=''
            name='emailResetPassword'
            rules={[
              {
                required: true,
                message: 'Email không được để trống.',
              },
              {
                required: !!emailResetPassword,
                message: 'Email không hợp lê.',
                pattern: new RegExp(/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/g),
              },
              {
                required: !!emailResetPassword,
                message: 'Độ dài tên trước @ của email từ 3 tới 30 ký tự',
                pattern: new RegExp(/^([a-zA-Z0-9.]{3,30})+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/g),
              },
            ]}
          >
            <Input placeholder='Email của bạn' onChange={(e) => setEmailResetPassword(e.target.value)} />
          </Form.Item>
          <Form.Item style={{ textAlign: 'right' }}>
            <Button block type='primary' htmlType='submit' loading={isLoadingResetPassword} disabled={isDisableResetPasswodBtn}>
              Gửi
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
